export function shortDate(isoShortDate) {
  if (!isoShortDate || !isoShortDate.match(/^\d{4}-\d{2}-\d{2}$/))
    return isoShortDate;
  const [year, month, day] = isoShortDate.split('-');
  return `${parseInt(month)}/${parseInt(day)}/${year}`;
}
